import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// import Highcharts from 'highcharts/es-modules/masters/highcharts.src.js';
// import HighchartsReact from 'highcharts-react-official';
import { selectors } from 'state';
import { formatters } from 'services';
import { OptionsContractType } from '../../../state/app/options/types';

interface OptionsChainTableProps {
  asset_id: number;
  expiration: string;
}

interface OptionsChainRow {
  strike: number;
  call?: OptionsContractType;
  put?: OptionsContractType;
}

const SmileChart: React.FC<OptionsChainTableProps> = ({
  asset_id,
  expiration,
}) => {
  const dispatch = useDispatch();
  const optionsContracts: OptionsContractType[] =
    useSelector(selectors.assetOptionsContracts(asset_id)) || [];
  const underlyingSpot = useSelector(selectors.underlyingSpot(asset_id));
  const { scenario_date } = useSelector(selectors.activeSession);

  // 1. Group by strike, filter by expiration
  const chainRows: OptionsChainRow[] = useMemo(() => {
    let tickSize = 10;
    if (underlyingSpot) {
      if (underlyingSpot <= 10) tickSize = 1;
      else if (underlyingSpot <= 25) tickSize = 5;
      else if (underlyingSpot <= 100) tickSize = 10;
      else if (underlyingSpot <= 250) tickSize = 25;
      else if (underlyingSpot <= 500) tickSize = 50;
      /* up to 1000 or above */ else tickSize = 100;
    }

    const grouped: { [strike: number]: OptionsChainRow } = {};

    optionsContracts.forEach(option => {
      if (option.expiration !== expiration) {
        return; // Skip if expiration doesn't match
      }

      // if contract doesn't satisfy correct tick size, don't show it
      if (!Number.isInteger(option.strike / tickSize)) return;

      if (!grouped[option.strike]) {
        grouped[option.strike] = { strike: option.strike };
      }

      // Assign call/put based on type
      if (option.type_int === 0) {
        grouped[option.strike].call = option;
      } else if (option.type_int === 1) {
        grouped[option.strike].put = option;
      }
    });

    return Object.values(grouped).sort((a, b) => a.strike - b.strike);
  }, [optionsContracts, expiration]);

  // 2. Build smile data
  const smileData = useMemo(() => {
    if (underlyingSpot === undefined) return [];

    return chainRows
      .map(row => {
        let impliedVol: number | undefined;

        if (row.strike < underlyingSpot) {
          // For OTM puts
          impliedVol = row.put?.implied_volatility;
        } else if (row.strike > underlyingSpot) {
          // For OTM calls
          impliedVol = row.call?.implied_volatility;
        } else {
          // ATM - average calls and puts if both exist
          if (row.call && row.put) {
            impliedVol =
              (row.call.implied_volatility + row.put.implied_volatility) / 2;
          } else if (row.call) {
            impliedVol = row.call.implied_volatility;
          } else if (row.put) {
            impliedVol = row.put.implied_volatility;
          }
        }

        // Filter out rows lacking a valid implied volatility
        if (impliedVol === undefined) return null;

        return {
          strike: row.strike,
          impliedVol,
        };
      })
      .filter(Boolean) as { strike: number; impliedVol: number }[];
  }, [chainRows, underlyingSpot]);

  const scenarioDate = new Date(scenario_date); // scenario_date from activeSession (e.g. '2025-01-10T00:00:00Z')
  const expirationDate = new Date(expiration); // e.g. '2025-01-17'
  // Compute the difference in milliseconds
  const diffMs = expirationDate.getTime() - scenarioDate.getTime();
  // Convert difference to days, rounding up (or using Math.floor if you prefer)
  const diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24));

  // 3. Configure Highcharts
  // const chartOptions: Highcharts.Options = {
  //   chart: {
  //     type: 'scatter',
  //     zooming: {
  //       type: 'x',
  //     },
  //     // height: '400px',
  //     // width: '900px',
  //   },
  //
  //   title: {
  //     text: `${diffDays}-day smile`,
  //   },
  //   xAxis: {
  //     title: { text: 'Strike' },
  //   },
  //   yAxis: {
  //     title: { text: 'Implied Volatility' },
  //     labels: {
  //       // Example: display "30%" if impliedVol=30
  //       formatter: function () {
  //         // return `${(this.value as number).toFixed(2)}%`;
  //         return `${formatters.percent0Digits(this.value)}`;
  //       },
  //     },
  //   },
  //   credits: { enabled: false },
  //   legend: { enabled: false },
  //
  //   tooltip: {
  //     formatter: function () {
  //       return `Strike ${this.x}<br/>IV: ${formatters.percent0Digits(this.y)}`;
  //     },
  //   },
  //
  //   // 4. Wrap smileData inside a single series object
  //   series: [
  //     {
  //       name: 'IV Smile',
  //       type: 'scatter',
  //       data: smileData.map(d => [d.strike, d.impliedVol]),
  //       // optional styling
  //       marker: { enabled: true },
  //     },
  //   ],
  // };

  // return (
  //   <HighchartsReact
  //     highcharts={Highcharts}
  //     options={chartOptions}
  //     // style={{ width: '600px' }}
  //   />
  // );
  return (
    <div>
      Highcharts removed, this part of the code was not yet rewrote to use
      ApexChart
    </div>
  );
};

export default SmileChart;
